import { Dialog, DialogTitle, List, ListItem, ListItemButton, ListItemText, styled } from '@mui/material';
import { CommandType, commandOptions, commandTypesDisplay } from '@shared/constants/CommandValues';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Icons from '../../core/images/Icons';
import { MobileOnlyTag } from '../../core/text/ContentTypography';

interface CommandPickerDialogProps {
    open: boolean;
    onClose: () => void;
    onCommandTypeSelected: (commandType: CommandType) => void;
}

const CommandPickerDialog: React.FC<CommandPickerDialogProps> = ({ open, onClose, onCommandTypeSelected }) => {
    const { t } = useTranslation();
    // write a function to check if the commandType is 'tilt' or 'hotkey' and return true or false
    const isMobileOnly = (commandType: CommandType): boolean => {
        return commandType === 'tilt';
    };
    return (
        <>
            <Dialog open={open} onClose={onClose}>
                <DialogTitle>{t('common:input.typeLabel')}</DialogTitle>
                <List>
                    {commandOptions.map((c, i) => (
                        <ListItem key={`commandtype-${i}`}>
                            <ListItemButton onClick={() => onCommandTypeSelected(c)}>
                                <StyledIcons size={35} name={commandTypesDisplay[c].icon} />
                                <ListItemText>{t(commandTypesDisplay[c].title)}</ListItemText>
                                {isMobileOnly(c) && <MobileOnlyTag>{t('common:mobileApp.title')}</MobileOnlyTag>}
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Dialog>
        </>
    );
};

const StyledIcons = styled(Icons)`
    padding-right: 5px;
`;

export default CommandPickerDialog;
